import { Injectable } from "@angular/core";
import { RestService } from "../../core/core/rest.service";
import { Customer, CustomerRow, CustomerEmployee, CustomerSystemVersion, License } from "./customers.model";
import { ObjectToSelect } from "../../core/shared/objectToSelect.model";

@Injectable()
export class CustomersRest {
    constructor(private http: RestService) { }

    public getCustomers() {
        return this.http.get<Customer[]>('api/customers');
    }

    public createCustomer() {
        return this.http.get<Customer>(`api/customer/createCustomer`);
    }

    public getEmployees(id: number) {
        return this.http.post<CustomerEmployee[]>(`api/customer/employees/grid/${id}`, {});
    }

    public getCustomerRowsByName(name: string) {
        return this.http.get<CustomerRow[]>(`api/customer/rows/${name}`);
    }

    public getCustomerDetails(id: number) {
        return this.http.get<Customer>(`api/customers/customer/${id}`);
    }

    public saveCustomer(customer: any, isNew: boolean) {
        return this.http.post(`api/customer/save/${isNew}`, customer);
    }

    public removeCustomer(customerId: number) {
        return this.http.post(`api/customer/delete/${customerId}`, {});
    }

    public getEmployeesToAdd() {
        return this.http.get<ObjectToSelect[]>('api/customer/getEmployeesToAdd');
    }

    public removeCustomerEmployee(customerEmployeeId: number) {
        return this.http.post(`api/customer/removeCustomerEmployee/${customerEmployeeId}`, {});
    }

    public editCustomerEmployee(employee: CustomerEmployee) {
        return this.http.post(`api/customer/edit`, employee);
    }

    public checkCurrentEmployeer(employeeId: number) {
        return this.http.get<string>(`api/customer/checkCurrentEmployeer/${employeeId}`);
    }

    public removeCustomerSystemVersions(id: number) {
        return this.http.post(`api/customer/systemVersions/remove/${id}`, {});
    }

    public removeWatcher(id: number) {
        return this.http.post(`api/customer/watchers/remove/${id}`, {});
    }

    public getCustomerEmployees(id: number) {
        return this.http.post<CustomerEmployee[]>(`api/customer/employees/${id}`, {});
    }

    public getCustomerSystemVersions(id: number) {
        return this.http.post<CustomerSystemVersion[]>(`api/customer/systemVersions/${id}`, {});
    }

    public addCustomerSystemVersion(customerId: number, systemVersionId: number) {
        return this.http.post(`api/customer/systemVersions/add/${customerId}/${systemVersionId}`, {});
    }

    public addCustomerEmployee(customerId: number, employeeId: number) {
        return this.http.post(`api/customer/addCustomerEmployee/${customerId}/${employeeId}`, {});
    }

    public getLicenses(customerId: number) {
        return this.http.get<License[]>(`api/customer/licenses/${customerId}`);
    }

    public saveLicense(license: License) {
        return this.http.post<License>('api/customer/licenses/save', license);
    }

    public deleteLicense(licenseId: number) {
        return this.http.post<boolean>(`api/customer/licenses/delete/${licenseId}`, {});
    }

    public blockCustomer(customerId: number) {
        return this.http.post<boolean>(`api/customer/blockCustomer/${customerId}`, {});
    }

    public unblockCustomer(customerId: number) {
        return this.http.post<boolean>(`api/customer/unblockCustomer/${customerId}`, {});
    }

    public existsCustomer(nip: string) {
        return this.http.get<boolean>(`api/customer/exists/${nip}`);
    }

}